import './UniversityList.css';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import actions from '../../redux/actions/index.js';
import { connect } from 'react-redux';
import CollegeMetaInfoList from '../admin/CollegeMetaInfoList.jsx';
import BackArrow from '../../public/icons/mycoach-backarrow.svg';
import NOImage from '../../public/icons/uni_thumb.png';
import NOCourses from '../../public/icons/no_courses.jpg';
import ForwardArrow from '../../public/icons/right-chevron.png';
import UpArrow from '../../public/icons/up-arrow.png';
import DownArrow from '../../public/icons/down-arrow.png';
import UserCourseEnrollmentList from './UserCourseEnrollmentList.jsx';
import ProgramByUniversityList from './UniversityByProgramList.jsx';
import ProgramDetails from '../university-courses/ProgramDetails';
import './CollegeMetaInfoList.css';

const UniversityList = (props) => {
  const { getInstituteProgramList, universityCourseEnrollment } = props;
  const [instituteProgram, setInstituteProgram] = useState(null);
  const [enrollment, setEnrollment] = useState(null);
  const [activeTab, setActiveTab] = useState("universities");
  const [searchQuery, setSearchQuery] = useState("");
  const userId = localStorage.getItem("user_id");
  const [selectedUni, setSelectedUni] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState(null);
  const [viewAllUniversities, setViewAllUniversities] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [enrollStatus, setenrollStatus] = useState(null);

  useEffect(() => {
    const fetchInstituteProgramList = async () => {
      if (typeof getInstituteProgramList !== 'function') {
        console.error("getInstituteProgramList is not a function");
        return;
      }

      try {
        const instituteProgramResp = await getInstituteProgramList();
        if (instituteProgramResp?.data) {
          setInstituteProgram(instituteProgramResp.data);
        } else {
          setInstituteProgram(null);
        }
      } catch (error) {
        console.error("Error fetching college info:", error);
        setInstituteProgram(null);
      }
    };
    fetchInstituteProgramList();
  }, [getInstituteProgramList]);

  const courseEnrollment = async (user_id, program_id, enroll_status) => {
    try {
      const courseEnrollmentResp = await universityCourseEnrollment(user_id, program_id, enroll_status);
      console.log("response is ", courseEnrollmentResp)

      if (courseEnrollmentResp?.data) {
        setEnrollment(courseEnrollmentResp.data);
        alert('Successfully Applied');
      } else {
        setEnrollment(null);
      }
    } catch (error) {
      console.error("Error enrolling in the course:", error);
      setEnrollment(null);
    }
  };

  const filteredUniversities = instituteProgram?.filter((uni) =>
    uni.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

 
  const coursesByUniversity = instituteProgram?.reduce((acc, uni) => {
    const filteredCourses = uni.programs.filter((course) =>
      course.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    
    acc.push({
      university: uni,
      courses: filteredCourses,
      viewAll: viewAllUniversities.includes(uni.id), 
    });
    return acc;
  }, []);

  const displayedCourses = viewAllUniversities.length > 0 ? coursesByUniversity : coursesByUniversity?.slice(0, 4);

  const handleViewAll = (uniId) => {
    setViewAllUniversities((prev) => {
      if (prev.includes(uniId)) {
        return prev.filter(id => id !== uniId); 
      } else {
        return [...prev, uniId]; 
      }
    });
  };

  return (
    <div className='app-body'>
      <div className='app-div mycoach-div uni-app-div'>
        
        {selectedUni != null ? (
          <CollegeMetaInfoList university={selectedUni} />
        ) : selectedCourses != null ? (
          selectedCourses && <ProgramByUniversityList uniCourses={selectedCourses} />
        ) : selectedProgram ? (
          <ProgramDetails


         
            program={selectedProgram}
            onBack={() => setSelectedProgram(null)} />
        )
          :
          (
            <>
              <div className="tab-buttons">
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}>
                  <div>
                    <h1>{activeTab === "universities" ? "All University" : activeTab === "courses" ? "All Courses" : "MY Interest"}</h1>
                  </div>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      style={{ margin: '4px 0px' }}
                      className={activeTab === "myInterest" ? "active" : ""}
                      onClick={() => setActiveTab("myInterest")}
                    >
                      My Interest
                    </button>
                    <button
                      style={{ margin: '4px 0px' }}
                      className={activeTab === "universities" ? "active" : ""}
                      onClick={() => setActiveTab("universities")}
                    >
                      Universities
                    </button>
                    <button
                      style={{ margin: '4px 0px' }}
                      className={activeTab === "courses" ? "active" : ""}
                      onClick={() => setActiveTab("courses")}
                    >
                      Courses
                    </button>
                    <input
                      type="text"
                      placeholder={activeTab === "universities" ? "Search University" : activeTab === "courses" ? "Search Courses" :  "Search enrolled courses"}
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent:'start',width: '100%'}}>
                {activeTab === "universities" && (
                  <div className="university-list">
                    {filteredUniversities?.map((uni) => (
                      <div
                        key={uni.id} 
                        onClick={() => setSelectedUni(uni)}
                        className="university-card"
                      >
                        <img
                          src={uni?.logo || NOImage}
                          alt={uni?.name || "University"}
                          onError={(e) => (e.target.src = NOImage)}
                          className="university-logo"
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                        <div className="university-details">
                          <h3>{uni.name}</h3>
                          <span>({uni.programs.length} courses)</span>
                        </div>
                       
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === "courses" && (
                  <div style={{ padding: '1.5rem', width: '100%' }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '2rem',
                    }}>
                      {coursesByUniversity?.map(({ university, courses, viewAll }) => (
                        <div key={university.id}>
                          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', justifyContent: 'space-between', width: '97%' }}>
                            <h2>{university.name}</h2>
                            <span onClick={() => handleViewAll(university.id)} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              {viewAll ? (
                                <>
                                  <span style={{ color: 'black', fontSize: "15px" }}>Show less</span>
                                  <img
                                    src={UpArrow}
                                    alt="Show less"
                                    style={{ width: '20px', height: '20px', fill: 'white' }}
                                  />
                                </>
                              ) : (
                                <>
                                  <span style={{ color: 'black', fontSize: "15px" }}>Show more</span>
                                  <img
                                    src={DownArrow}
                                    alt="Show more"
                                    style={{ width: '20px', height: '20px', fill: 'white' }}
                                  />
                                </>
                              )}
                            </span>
                          </div>

                          <div  className="news-container"
                         
                          >
                            {courses.slice(0, viewAll ? courses.length : 4).map((course) => (
                              <div
                                style={{position:'relative'}}
                                key={course.id}
                                className='news-item'
                               
                              >
                                <div>
                                  <img
                                    src={course.image || NOCourses}
                                    alt={course.label}
                                    style={{
                                      width: '100%',
                                      height: '150px',
                                      objectFit: 'cover',
                                      borderRadius: '0.25rem',
                                    }}
                                  />
                                  <h4 style={{
                                    fontSize: '1rem',
                                    fontWeight: '600',
                                    marginBottom: '0.5rem',
                                  }}>
                                    {course.label}
                                  </h4>
                                  <p style={{
                                    fontSize: '0.875rem',
                                    color: '#757575',
                                    marginBottom: '0.5rem',
                                  }}>
                                    {course.description || "N/A"}
                                  </p>
                                
                                </div>
                    
                                <div style={{ textAlign: 'center' }}>
                                 
                                  <span
                                    // onClick={() => courseEnrollment(userId, program.id)}
                                    onClick={() => setSelectedProgram(course)}
                                    style={{
                                      backgroundColor: "#000000",
                                      color: "#ffffff",
                                      // padding: "6px 20px",
                                      padding: '2px 20px 10px',
                                      fontSize: "12px",
                                      // paddingBottom: "10px",
                                      border: "none",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                      transition: "background-color 0.3s ease",
                                      position: 'absolute',
                                      bottom: '10px',
                                      left: '50%',
                                      transform: 'translate(-86px, 0)',
                                    }}
                                  >
                                    <span>View course details</span>
                                    <img
                                      src={ForwardArrow} 
                                      alt="View All Icon"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        objectFit: "contain",
                                        paddingTop: '10px',
                                        gap: '20px',
                                       background:'black'
                                      }}
                                    />
                                  </span>
                                </div>


                              </div>
                            ))}

                          </div>

                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {activeTab === "myInterest" && (
                  <UserCourseEnrollmentList university={selectedUni} />

                )}
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    instituteProgramList: state.instituteProgramList,
  }),
  actions
)(UniversityList);
